export default "__VITE_PUBLIC_ASSET__1ca8fc4b__"